import axios from 'axios'

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 10000,
    timeoutErrorMessage: 'TIMEOUT',
    headers: {
      'Content-Type': 'application/json',
      'x-twiceme-app-version': '1.0.0',
      'x-twiceme-client': 'twiceme-app',
    },
  })

  export default api 